import { render, staticRenderFns } from "./CostDatatable.vue?vue&type=template&id=0e66b840&scoped=true"
import script from "./CostDatatable.vue?vue&type=script&lang=js"
export * from "./CostDatatable.vue?vue&type=script&lang=js"
import style0 from "./CostDatatable.vue?vue&type=style&index=0&id=0e66b840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e66b840",
  null
  
)

export default component.exports